import "./index.css"
import { createRoot } from 'react-dom/client'
import fetchConfig from './apis/config'
import { OidcConfiguration, OidcProvider } from '@axa-fr/react-oidc'
import OpenIdStatusPage from './components/app/login/OpenIdStatusPage'
import { ThemeProvider } from "@mui/material";
import mikeSharedTheme from './styles/mikeSharedTheme';
import { BrowserRouter as Router } from 'react-router-dom'
import init from './apis/support/index'
import initPlatformProxy from './apis/PlatformProxy'
import AppWrapper from './components/app/AppWrapper'
import { createIntl, defineMessages, IntlProvider } from 'react-intl'
import messagesEn from "./messages/en";

interface IndexPropType {
  openIdConfig: OidcConfiguration;
}

const language = "en";
const messages = { en: messagesEn };
// export intl
const intl  = createIntl({ locale: 'en', messages: messagesEn})

const localMessages = defineMessages({ 
  headline: {
    id: 'openIdStatusPage.headline'
  },
  pleaseWait: {
    id: 'openIdStatusPage.pleaseWait'
  },
  errorHeadline: {
    id: 'openIdStatusPage.errorHeadline'
  },
  errorBody: {
    id: 'openIdStatusPage.errorBody'
  },
  loading: {
    id: 'openIdStatusPage.loading'
  }
})

// eslint-disable-next-line react-refresh/only-export-components
const Index = (props: IndexPropType) => {
  // const { login } = useOidc();
  const { openIdConfig } = props;

  return (
    <IntlProvider locale={language} messages={messages[language]}>
    <OidcProvider
      configuration={openIdConfig}
      /* onSessionLost={() => {
        login('/');
      }} */
      authenticatingComponent={() => (
        <OpenIdStatusPage  headline={intl.formatMessage(localMessages.headline)}
        body={intl.formatMessage(localMessages.pleaseWait)} />
      )}
      callbackSuccessComponent={() => (
        <OpenIdStatusPage headline={intl.formatMessage(localMessages.headline)}
        body={intl.formatMessage(localMessages.pleaseWait)} />
      )}
      authenticatingErrorComponent={() => (
        <OpenIdStatusPage
          headline={intl.formatMessage(localMessages.errorHeadline)}
          body={intl.formatMessage(localMessages.errorBody)}
          showRetryButton={true}
        />
      )}
      loadingComponent={() => <OpenIdStatusPage  headline={intl.formatMessage(localMessages.loading)}
      body={intl.formatMessage(localMessages.pleaseWait)} />}>
      <Router>
        <ThemeProvider theme={mikeSharedTheme}>
          <AppWrapper />
        </ThemeProvider>
      </Router>
    </OidcProvider>
    </IntlProvider>
  );
};

fetchConfig().then(response => {
  const config: any = response;
  const openIdConfig = {
    client_id: config.clientName,
    redirect_uri: `${window.location.origin}/authentication/callback`,
    silent_redirect_uri: `${window.location.origin}/authentication/silent-callback`,
    scope: 'openid offline_access',
    authority: config.loginUrl,
    service_worker_relative_url: '/OidcServiceWorker.js',
    service_worker_only: false,
    refresh_time_before_token_expiration_in_second: 120,
  };
  init(config);
  initPlatformProxy(config.platformApiUrl);
  navigator.serviceWorker.getRegistration().then(function(reg) {
    // On a hard refresh (shift + refresh) there's an active SW, but no controller for this tab.
    // https://stackoverflow.com/questions/51597231/register-service-worker-after-hard-refresh
    if (reg && reg.active && !navigator.serviceWorker.controller) {
      // Perform a soft reload to load everything from the SW and get
      // a consistent set of resources.
      window.location.reload();
    }
  });
  createRoot(document.getElementById('root')!).render(<Index openIdConfig={openIdConfig} />);
});
